import { graphql, useStaticQuery } from "gatsby";
import Markdown from "markdown-to-jsx";
import React from "react";
import styles from "./LegalFooter.module.scss";

const LegalFooter: React.FC = () => {
  const data = useStaticQuery(graphql`
    query LegalQuery {
      data: markdownRemark(fileAbsolutePath: { regex: "/contact.md/" }) {
        frontmatter {
          legal_footer
        }
      }
    }
  `);

  return (
    <div className={styles.banner}>
      <Markdown>{data.data.frontmatter.legal_footer}</Markdown>
    </div>
  );
};

export { LegalFooter };
